export function production(): boolean {
  return process.env.NODE_ENV === 'production';
}
